import React, { useEffect, useState } from "react";
import Footer from "../Components/Footer";
import YachtSlider from "../Components/YachtSlider";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";
import { getMainImageUrl } from "../utils/fleetCardMedia";

const getCardImage = (card) => {
  const imageUrl = getMainImageUrl(card);

  if (!imageUrl) {
    return "/assets/img/boat1.jpg";
  }

  if (
    imageUrl.startsWith("http") ||
    imageUrl.startsWith("/uploads/") ||
    imageUrl.startsWith("/assets/")
  ) {
    return imageUrl;
  }

  if (imageUrl.startsWith("assets/")) {
    return `/${imageUrl}`;
  }

  return imageUrl;
};

export default function Deals() {
  const [boatData, setBoatData] = useState([]);

  useEffect(() => {
    const fetchBoats = async () => {
      try {
        const res = await fetch("/api/experiences");
        const pages = await res.json();

        if (!Array.isArray(pages)) {
          return;
        }

        const flattened = pages.flatMap((page) =>
          (page.fleetCards || []).map((card) => ({
            pageName: page.pageName || "Other",
            pageKey: page.pageKey || "",
            card,
          }))
        );

        setBoatData(flattened);
      } catch (err) {
        console.error("Error fetching boats:", err);
      }
    };

    fetchBoats();
  }, []);

  const groupedBoats = boatData.reduce((acc, item) => {
    const key = item.pageName || "Other";
    const card = item.card || {};

    if (!acc[key]) {
      acc[key] = {
        boats: [],
        categoryName: item.pageName || "",
        locationName: card.inMumbai ? "Mumbai" : card.inGoa ? "Goa" : "",
        placeName: "",
        typeOfBoatName: card.type || "",
        typeOfYachtName: card.category || card.title || "",
      };
    }

    if (acc[key].boats.length < 10) {
      acc[key].boats.push({
        id: card._id,
        slug: card.slug,
        title: card.title || card.category || "Yacht",
        desc: card.desc || "",
        img: getCardImage(card),
      });
    }

    return acc;
  }, {});

  return (
    <>
      <IndiaBoatsTopBar />
      <PremiumNavbar />
      <section className="container" style={{ padding: "50px 0" }}>
        {Object.entries(groupedBoats).map(([subCategory, group]) => (
          <section key={subCategory} className="tour-area space">
            <div className="container">
              <div className="text-center">
                <h3 className="sec-title" id="sec_title_slider">
                  {subCategory} <span>({group.boats.length} Boats)</span>
                </h3>

                <h4>{group.categoryName}</h4>

                <p>
                  {group.locationName}
                  {group.placeName ? ` - ${group.placeName}` : ""}
                </p>

                <p>
                  {group.typeOfBoatName}
                  {group.typeOfYachtName ? ` | ${group.typeOfYachtName}` : ""}
                </p>
              </div>

              <YachtSlider data={group.boats} />
            </div>
          </section>
        ))}
      </section>
      <Footer />
    </>
  );
}
